import React from 'react';
import { Row, Col } from 'antd';
import AboutTile from '../../AbouTile';
import { stripTags, domHtml } from '../../../utils/stripTags';

import SEO from '../../Seo';

const pageText = {
  paraOne: `I'm a technical lead on a team that builds and runs the issuance infrastructure behind
   regulated stablecoins carrying more than $4B in on-chain supply: mint and burn pipelines, supply
   controllers, and reserve operations. The same token has to work on EVM, Solana, Tron and Aptos,
   and every one of those chains has a different account model and a different idea of what freezing
   an address means, which makes supply reconciliation the interesting part of the job.`,
  paraTwo: `I led the smart contract work for the stablecoin platform, brought Arbitrum and Optimism
   into the custody platform, and look after the infrastructure powering WBTC. Earlier I was a lead
   engineer at NetObjex building blockchain applications for enterprise customers, and I contributed
   to the Helix Network's desktop wallet and its SDK. I speak about stablecoin infrastructure and
   regulated token architecture, and I run workshops and technical sessions when I get the chance.`,
};

const AboutMe = () => {
  const description = `${pageText.paraOne} ${stripTags(pageText.paraTwo)}`;
  return (
    <>
      <div>
        <SEO
          title="About"
          description={description}
          path=""
          keywords={['Sachu', 'Shaji', 'Abraham', 'stablecoin infrastructure', 'smart contracts', 'blockchain', 'EVM', 'Solana']}
        />
        <h1 className="titleSeparate">About Me</h1>
        <p>
          {pageText.paraOne}
        </p>
        <p dangerouslySetInnerHTML={domHtml(pageText.paraTwo)} />
      </div>
      <Row gutter={[20, 20]}>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="location.png"
            height={60}
            alt="location image"
            textH4="Born and brought up in"
            textH3="Kottayam, KL, India"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="coffee.png"
            alt="coffee image"
            textH4="Love Coffee"
            textH3="Coffee + Me = Happiness"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="open-source.png"
            alt="open source"
            textH4="Open Source"
            textH3="Nautilus Wallet, Pendulum SDK"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="presenter.png"
            alt="Preseneter"
            textH4="Speaker on"
            textH3="Stablecoin & token architecture"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="web.png"
            alt="web image"
            textH4="Ships on"
            textH3="EVM · Solana · Tron · Aptos"
            height={60}
            width={60}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={8}>
          <AboutTile
            img="graduation.png"
            alt="graduation image"
            textH4="Pursued B.Tech in"
            textH3="Computer Science"
            height={60}
            width={60}
          />
        </Col>
      </Row>
    </>
  );
};
export default AboutMe;
